export class RaskDataChanged {
    model: any;
    field: string;
    value: any;
    constructor(model: any, field: string, value: any) {
        this.model = model;
        this.field = field;
        this.value = value;
    }
}
